import React, { useRef, useState } from 'react';
import { RegularButton, Badge } from 'fronton-react';
import { UserCircleIcon } from '@fronton/icons-react';
import { HeaderModelData } from 'types/model';
import { WithAuthProps } from 'components/header/hoc/with-auth';
import { useTranslation } from 'react-i18next';
import { ProIcon } from 'components/icons';
import { useShoppingList, useHeaderAnalyticsEvent } from 'components/header/hooks';
import { useHandleEscPress } from 'common/hooks/use-handle-esc-press';
import { UserMenu } from './user-menu';
import { badge, root, ProIconWrapper } from './styles';
import { LOYALTY_PRO_ICON_QA, NEED_ACTION_BADGE_QA } from './constants/qa-constants';
import { useLoyaltyData } from 'common/hooks/use-loyalty-data';

export interface UserProps extends WithAuthProps {
  model: HeaderModelData;
}

export const User = (props: UserProps) => {
  const { model, ...authProps } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const { shoppingListCount } = useShoppingList();
  const { fetchedLoyaltyAccountSuccess, keycardPro, loyaltyAccountIdentifier } = useLoyaltyData();

  const { t } = useTranslation();

  const [show, setShow] = useState<boolean>(false);

  useHandleEscPress(() => setShow(false), show);

  const onAccountEvent = useHeaderAnalyticsEvent('account');

  const onMenuOpen = () => {
    if (!show) {
      setShow(true);
      onAccountEvent();
    }
  };

  const showBadge = fetchedLoyaltyAccountSuccess && !loyaltyAccountIdentifier;
  const showProCardLabel = fetchedLoyaltyAccountSuccess && keycardPro;

  return (
    <div data-qa="user-menu" className={root} ref={containerRef}>
      <UserMenu
        show={show}
        title={t('header.main.profile')}
        shoppingListCount={shoppingListCount}
        shoppingListUrl={model.header.shoppingList}
        logout={authProps.logout}
        onClose={() => setShow(false)}
      >
        <RegularButton
          size="l"
          data-qa="user-icon"
          iconOnly
          label={t('header.main.profile-low')}
          rounded
          disabled={show}
          onClick={onMenuOpen}
          variant="secondary"
        >
          <UserCircleIcon type="outline" />
        </RegularButton>
      </UserMenu>
      {showBadge && <Badge data-qa={NEED_ACTION_BADGE_QA} size="xs" value={1} className={badge} />}
      {showProCardLabel && (
        <ProIconWrapper data-qa={LOYALTY_PRO_ICON_QA}>
          <ProIcon />
        </ProIconWrapper>
      )}
    </div>
  );
};
